import { safeLazy } from '@beef/react/utils';
export { SearchSideBarRC } from "./SearchSideBar";
export var Search = safeLazy(function () {
  return import("./Search").then(function (module) {
    return {
      default: module.Search
    };
  });
});
export { ButtonHeaderSearchRC } from "./blocks/Buttons";
export { getIsWebview } from "./utils/getIsWebView";